/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'jquery',
	'underscore',
	'../../../app/nls/StringResources',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/OnLoadFilterModifier'
], ($, _, stringResources, APIFactory, OnLoadFilterModifierAPI) => {

	class OnLoadFilterModifier {
		constructor(options) {
			this.dashboard = options.features['API'];
			this.datasources = options.features['DataSources'];
			this.moserDatasources = options.features['DataSources.moser'];
			this.globalFilters =  options.features['GlobalFilters'];
			this._api = APIFactory.createAPI(this, [OnLoadFilterModifierAPI]);
			this._itemIds = [];
			this.moserDatasources.registerMetadataSubsetIdsProvider(this._api);
		}

		initialize() {

			const contentView = this.dashboard.getCurrentContentView();
			const sFilters = contentView.getContent().filters;

			if(!sFilters) {
				return Promise.resolve();
			}
			const datasourceByAssetId = {};
			const filters = JSON.parse(sFilters);
			this.datasources.getDataSourceList().forEach(dataSource => {
				datasourceByAssetId[dataSource.getAssetId()] = dataSource;
			});
			const datasourceAssetIds = Object.keys(datasourceByAssetId);
			const sourceMatchedFilters = filters.filter(filter => {
				return datasourceAssetIds.includes(filter.assetId);
			});
			if(sourceMatchedFilters.length !== filters.length) {
				this.dashboard.showToast(stringResources.get('OnLoadFilterModifierDatasourceMismatch'), { type: 'info' });
			}
			if(!sourceMatchedFilters.length) {
				return Promise.resolve();
			}

			this._itemIds = sourceMatchedFilters.map(filter => filter.columnId).filter(Boolean);

			const usedDataSourceAssetIds = _.uniq(sourceMatchedFilters.map(filter => filter.assetId));
			const loadMetadataPromises = [];
			usedDataSourceAssetIds.forEach(assetId => {
				const datasource = datasourceByAssetId[assetId];
				loadMetadataPromises.push(datasource.loadMetadata());
			});

			return Promise.all(loadMetadataPromises)
				.then(() => {
					let columnNotFoundDisplayed;
					let filterSet;
					sourceMatchedFilters.forEach(filter => {
						const scope = filter.scope || 'global';
						const assetId = filter.assetId;
						const columnId = filter.columnId;
						const datasource = datasourceByAssetId[assetId];
						delete filter.scope;
						delete filter.assetId;
						if(datasource.getMetadataColumn(filter.columnId)) {
							this.globalFilters.removeFilters({ itemId: columnId });
							this.globalFilters.getFilters(datasource.getId(), scope)
								.addFilter({ itemId: columnId }, filter );
							filterSet = true;
						} else if(!columnNotFoundDisplayed) {
							this._displayColumnNotFound();
							columnNotFoundDisplayed = true;
						}
					});
					if(filterSet) {
						this.dashboard.setDirty(true);
					}
				});
		}

		getMetadataSubsetIds() {
			return this._itemIds;
		}

		_displayColumnNotFound() {
			this.dashboard.showToast(stringResources.get('OnLoadFilterModifierColumnMismatch'), { type: 'info' });
		}

		getAPI() {
			return this._api;
		}

	}

	return OnLoadFilterModifier;
});
